import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-item-quantity-warning',
  templateUrl: './product-item-quantity-warning.component.html',
  styleUrls: ['./product-item-quantity-warning.component.scss'],
})
export class ProductItemQuantityWarningComponent implements OnInit {
  @Input() title?: string | null = null;
  @Input() messageHtml!: string;
  @Input() initExpanded: boolean = false;

  isExpanded = false;

  constructor() {}

  ngOnInit(): void {
    this.isExpanded = this.initExpanded;
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }
}
